// extracted by mini-css-extract-plugin
export default {"sliderSection":"Slider_sliderSection__qxEGq","withBlueBgCont":"Slider_withBlueBgCont__0zpi0","ImgCont":"Slider_ImgCont__1cJPF"};